import axios from "./api"

export const compendiumApi = {
    getCompendiumById(request) {
        return axios.get(`/api/compendiums/${request.compendiumId}?range_start=${request.rangeStart}&result_limit=${request.resultLimit}`);
    },
    postSearchRequest(request) {
        return axios.post(`/api/compendium/search`, request);
    },
    getPendingModeration(excludeIds = []) {
        const params = excludeIds.length > 0 ? `?exclude_ids=${excludeIds.join(',')}` : '';
        return axios.get(`/api/compendium/pending-review${params}`);
    }
}
